import { createApiSlice } from "@common";
import {
  CRUD_CONTACT_COMMUNICATION,
  GET_CONTACT_COMMUNICATION_BY_CONTACT_ID,
} from "@routes";

const apiConfig = [
  {
    name: "addContactCommunication",
    method: "post",
    url: CRUD_CONTACT_COMMUNICATION,
    stateKey: "message",
  },
  {
    name: "getContactCommunicationByContactId",
    method: "get",
    url: GET_CONTACT_COMMUNICATION_BY_CONTACT_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "contactCommunication",
  apiConfig,
  customReducers
);

const contactCommunicationSlice = slice;

export default contactCommunicationSlice.reducer;

export const {
  addContactCommunication,
  getContactCommunicationByContactId,
} = thunks;

export const { rowSelect, setAdditionalData } = actions;
